window.addEventListener('load',function(){
    const observerPoint = window.document.getElementById('UnblurHeader');
    const header = window.document.querySelector('header#SiteHeader div.site-header__element--top');
    
    if(!header || !observerPoint) return;

    let observer = new IntersectionObserver(entry => {
                
        if( entry[0].boundingClientRect.y < 0)
            header.classList.add('unblur');
        else
            header.classList.remove('unblur');
    })

    observer.observe(observerPoint);
})